var getRadiumStyleState = function getRadiumStyleState(component) {
  return component._lastRadiumState || component.state && component.state._radiumStyleState || {};
};

export default getRadiumStyleState;


//////////////////
// WEBPACK FOOTER
// ./~/radium/es/get-radium-style-state.js
// module id = 175
// module chunks = 0